import { Button } from 'devextreme-react';

export const FilterNavigationHeader = ({ 
    stepTitle, 
    currentStep, 
    totalSteps, 
    activeFiltersCount, 
    onBack, 
    onNext,
    onApply,
    filterName,
    showApply = false
}) => {
    return (
        <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "1rem",
            backgroundColor: "#ffffff",
            borderBottom: "2px solid #007bff",
            marginBottom: "1rem",
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0,123,255,0.15)",
            flexShrink: 0
        }}>
            <div style={{
                display: "flex",
                alignItems: "center",
                gap: "1rem"
            }}>
                <h3 style={{
                    margin: 0,
                    color: "#007bff",
                    fontSize: "18px",
                    fontWeight: "600"
                }}>{stepTitle}</h3>
                
                {/* Progress Indicator */}
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                    padding: "0.25rem 0.75rem",
                    backgroundColor: "#e3f2fd",
                    borderRadius: "20px",
                    fontSize: "12px",
                    color: "#1976d2"
                }}>
                    <span style={{
                        width: "6px",
                        height: "6px",
                        backgroundColor: "#007bff",
                        borderRadius: "50%"
                    }}></span>
                    Step {currentStep} of {totalSteps}
                </div>
                
                {activeFiltersCount > 0 && (
                    <div style={{
                        backgroundColor: "#28a745",
                        color: "white",
                        padding: "0.25rem 0.75rem",
                        borderRadius: "12px",
                        fontSize: "12px",
                        fontWeight: "500"
                    }}>
                        {activeFiltersCount} Active Filter{activeFiltersCount !== 1 ? 's' : ''}
                    </div>
                )}
            </div>
            
            {/* Navigation Buttons */}
            <div style={{
                display: "flex",
                gap: "0.75rem",
                alignItems: "center"
            }}>
                <Button
                    icon="chevronleft"
                    text="Back"
                    onClick={onBack || (() => console.log("Back clicked"))}
                    hint="Go to previous step"
                    stylingMode="outlined"
                />
                {showApply ? (
                    <Button
                        icon="check"
                        text="Apply Filter"
                        onClick={onApply || (() => console.log("Apply clicked"))}
                        hint="Apply the filter configuration"
                        disabled={!filterName || filterName.trim() === ""}
                        stylingMode="contained"
                        type="success"
                    />
                ) : (
                    <Button
                        icon="chevronright"
                        iconPosition="after"
                        text="Next"
                        onClick={onNext || (() => console.log("Next clicked"))}
                        hint="Proceed to next step"
                        disabled={activeFiltersCount === 0}
                        stylingMode="contained"
                        type="success"
                    />
                )}
            </div>
        </div>
    );
};
